import { PUSH_UPLOADED_PHOTO } from '../actionTypes'

export const pushUploadedPhoto = (photo: object) => ({
  type: PUSH_UPLOADED_PHOTO,
  payload: { photo },
})
